import AppHeader from "../../layout/AppHeader";
import Notification from '../../xpost/views/comum/notification/Notification.vue';

const NotificationRoutes = [
    {
        path: "/notifications",
        name: "notification",
        props: route => ({ query: route.query.to }),
        components: {
            header: AppHeader,
            default: Notification,
        }
    },
]

export default NotificationRoutes;